import { StackProps, Stack } from "@mui/material";

const ICON_STYLE = {
  height: "24px",
  width: "24px",
  borderRadius: "8px",
  bgcolor: "shades.ghost.500",
};
const ModuleIcon = ({ ...props }: StackProps) => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={ICON_STYLE}
      {...props}
    />
  );
};
export default ModuleIcon;
